export var FETCH_BACKOFF_BASE = 10000; // backoff base starting at 10 seconds
export var FETCH_BACKOFF_MAX_WAIT = 60000; // don't wait for more than 1 minute
export var FETCH_BACKOFF_MAX_RETRIES = 10; // max retries
